import React, {useState, useEffect} from 'react';
import Get from './components/Get';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import './home.css';
import {MdArrowForward} from 'react-icons/md';
import {FaWhatsapp} from 'react-icons/fa';
import {useNavigate} from 'react-router-dom';
import BottomTabs from './BottomTabs';

const Home = () => {
  const [user, setUser] = useState(null);
  const [balance, setBalance] = useState(0);
  const [sidebar, setSidebar] = useState(false);
  const [games, setGames] = useState([]);
  const navigate = useNavigate();
  const [message, setMessage] = useState(null);
  const [showResultModal, setShowResultModal] = useState(false);
  const [helpNumber, setHelpNumber] = useState('');
  const featuredGame = games.find(game => game.result) || games[0];

  useEffect(() => {
    Get.Setting().then(res => {
      if (res.data) {
        localStorage.setItem('setting', JSON.stringify(res.data));
        setMessage(res.data.banner);
        // Get help number if available
        if (res.data.help && res.data.help.text) {
          setHelpNumber(res.data.help.text);
        }
      }
    });
  }, []);

  useEffect(() => {
    // Retrieve user from localStorage
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    fetchWallet();
    fetchGames();
  }, []);

  const fetchWallet = () => {
    Get.Wallet().then(res => {
      if (res.wallet && typeof res.wallet.balance !== 'undefined') {
        setBalance(res.wallet.balance);
      } else {
        setBalance(0); // fallback value
      }
    });
  };

  const fetchGames = () => {
    Get.Result().then(res => {
      setGames(res.games || []);
    });
  };

  const openWhatsApp = () => {
    const whatsappMessage = 'Hello, I need help';
    let whatsappUrl;

    if (helpNumber) {
      whatsappUrl = `https://wa.me/91${helpNumber}?text=${encodeURIComponent(
        whatsappMessage,
      )}`;
    } else {
      whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
        whatsappMessage,
      )}`;
    }

    window.open(whatsappUrl, '_blank');
  };

  useEffect(() => {
    const handleBackButton = event => {
      event.preventDefault();
      const confirmLogout = window.confirm(
        'Are you sure you want to logout and exit?',
      );
      if (confirmLogout) {
        localStorage.clear();
        navigate('/');
      } else {
        window.history.pushState(null, '', window.location.href);
      }
    };

    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [navigate]);

  return (
    <>
      <div className="home-container">
        <Header
          showUser={true}
          sidebar={value => setSidebar(value)}
          balance={balance}
          showBackButton={false}
        />

        <main className="home-content">
          <section className="account-card" aria-label="Account overview">
            <div className="account-avatar">{user?.name?.charAt(0) || 'U'}</div>
            <div className="account-details">
              <strong>{user?.name || 'User'}</strong>
              <span>{user?.mobile || '0000000000'}</span>
            </div>
            <div className="account-balance">
              <span>Balance</span>
              <strong>₹ {Number(balance || 0).toFixed(2)}</strong>
            </div>
          </section>

          <section className="featured-result" aria-label="Latest game result">
            <div className="live-label">
              <span /> Live Result
            </div>
            <div className="featured-number">
              {featuredGame?.result?.number ?? '--'}
            </div>
            <div className="featured-game-name">
              {featuredGame?.name?.name || "Today's Result"}
            </div>
            <button
              onClick={() => setShowResultModal(true)}
              className="resultButton">
              <span className="resultButtonText">Play Now</span>
              <MdArrowForward size={18} />
            </button>
          </section>

          {showResultModal && (
            <div
              className="modalOverlay"
              onClick={() => setShowResultModal(false)}>
              <div
                className="modalContent"
                onClick={event => event.stopPropagation()}>
                <div className="modalGradient">
                  <div className="modalHeader">
                    <h2 className="modalTitle">Latest Result</h2>
                    <button
                      onClick={() => setShowResultModal(false)}
                      className="modalCloseButton"
                      aria-label="Close result">
                      ×
                    </button>
                  </div>
                  <div className="modalResultContainer">
                    <h1 className="modalResultNumber">
                      {featuredGame?.result?.number ?? '--'}
                    </h1>
                    <p className="modalGameName">
                      {featuredGame?.name?.name || 'No result available'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="announcement-banner">
            {message?.text ||
              message ||
              'Check back for the latest game announcements.'}
          </div>

          <section className="results-section">
            <div className="section-heading">
              <h2>Today&apos;s Games</h2>
              <span />
            </div>
            <div className="games-container">
              {games.map((data, index) => (
                <button
                  key={data._id || `${data.name?.name || 'game'}-${index}`}
                  className="game-card"
                  onClick={() => navigate('/gamelist')}>
                  <span className="game-result-number">
                    {data.result?.number ?? '--'}
                  </span>
                  <span className="game-title">
                    {data.name?.name || 'Game'}
                  </span>
                  <span className="game-time">
                    {data.result_time || 'Result time unavailable'}
                  </span>
                  <span className="game-arrow" aria-hidden="true">
                    ›
                  </span>
                </button>
              ))}
            </div>
          </section>
        </main>

        <Sidebar
          visible={sidebar}
          balance={balance}
          onClose={() => setSidebar(false)}
        />

        {/* Floating WhatsApp Button */}
        <button onClick={openWhatsApp} style={styles.whatsappFloat}>
          <FaWhatsapp size={32} color="#fff" />
        </button>
      </div>
      <BottomTabs />
    </>
  );
};

const styles = {
  whatsappFloat: {
    position: 'fixed',
    bottom: '78px',
    right: '18px',
    width: '54px',
    height: '54px',
    borderRadius: '50%',
    backgroundColor: '#20c86b',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 6px 20px rgba(32, 200, 107, 0.32)',
    zIndex: 1000,
  },
};

export default Home;
